export const getRegistrationFormStyles = (height, mode = 'register', previewLayout, isStackedViewport = false, hideInlineSummary = false) => {
    const isPreviewMobile = mode === 'preview' && previewLayout === 'mobile';
    const isPreviewTablet = mode === 'preview' && previewLayout === 'tablet';
    const isPreviewStacked = isPreviewMobile || isPreviewTablet;
    const isStackedLayout = isPreviewStacked || (mode === 'register' && isStackedViewport);
    const isRegisterMode = mode === 'register';
    const contentPx = isRegisterMode
        ? { xs: 1.25, sm: 1.5, md: 2.5, lg: 3 }
        : isPreviewMobile
            ? 1.5
            : isPreviewTablet
                ? 2
                : { xs: 3, md: 4 };
    const contentPt = isRegisterMode
        ? { xs: 1.25, sm: 1.5, md: 2.5, lg: 3 }
        : isPreviewMobile
            ? 1.5
            : isPreviewTablet
                ? 2
                : { xs: 3, md: 4 };
    const contentPb = isRegisterMode
        ? { xs: 0.75, sm: 1, md: 1.25, lg: 1.5 }
        : isPreviewMobile
            ? 1
            : isPreviewTablet
                ? 1.25
                : { xs: 1.5, md: 2 };
    const isSideBySide = !isStackedLayout &&
        (mode === 'register' || (mode === 'preview' && previewLayout === 'desktop'));
    const panelMinHeight = isStackedLayout
        ? 'auto'
        : isSideBySide
            ? (height ?? '100%')
            : { xs: 'auto', lg: height ?? 'calc(100dvh - 200px)' };
    return {
        root: {
            flex: 1,
            width: '100%',
            height: '100%',
            minHeight: 0,
            maxHeight: '100%',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            maxWidth: isStackedLayout ? '100%' : { xs: '100%', sm: 640, md: 800, lg: 1240 },
            alignSelf: 'stretch',
            mx: 'auto',
            pt: isPreviewStacked ? 0.5 : { xs: 0.5, sm: 1, md: 1.5, lg: 2 },
            pb: isPreviewStacked ? 1 : { xs: 1, sm: 1.5, md: 0 },
            px: 0,
            boxSizing: 'border-box'
        },
        formGrid: {
            width: '100%',
            alignItems: 'stretch',
            flex: 1,
            minHeight: 0,
            maxHeight: '100%',
            height: isSideBySide || isStackedLayout ? '100%' : undefined,
            overflow: 'hidden',
            ...(isStackedLayout && {
                display: 'flex',
                flexDirection: 'column',
                flexWrap: 'nowrap'
            })
        },
        formColumn: {
            minWidth: 0,
            display: 'flex',
            alignSelf: 'stretch',
            minHeight: 0,
            height: isSideBySide || (isStackedLayout && hideInlineSummary) ? '100%' : isStackedLayout ? 'auto' : undefined,
            maxHeight: isSideBySide || (isStackedLayout && hideInlineSummary)
                ? '100%'
                : isPreviewMobile
                    ? '68%'
                    : isPreviewTablet
                        ? '62%'
                        : isStackedLayout && isRegisterMode
                            ? { xs: '78%', sm: '72%' }
                            : isStackedLayout
                                ? '65%'
                                : undefined,
            overflow: 'hidden',
            ...(isStackedLayout &&
                hideInlineSummary && {
                flex: '1 1 auto',
                minHeight: 0
            }),
            ...(isStackedLayout &&
                !hideInlineSummary &&
                isRegisterMode && {
                flex: '1 1 58%',
                minHeight: { xs: 280, sm: 320 }
            }),
            ...(isStackedLayout &&
                !hideInlineSummary &&
                !isRegisterMode && {
                flex: '0 1 auto',
                flexShrink: 0
            })
        },
        formCard: {
            flex: 1,
            width: '100%',
            height: '100%',
            minHeight: isSideBySide ? 0 : panelMinHeight,
            maxHeight: '100%',
            alignSelf: 'stretch',
            overflow: 'hidden'
        },
        summaryWrap: {
            display: 'flex',
            flexDirection: 'column',
            position: isStackedLayout ? 'static' : { xs: 'static', lg: 'sticky' },
            top: isStackedLayout ? undefined : { lg: 96 },
            alignSelf: 'stretch',
            flexShrink: isStackedLayout && !isRegisterMode ? 1 : 0,
            maxWidth: isStackedLayout ? '100%' : { xs: '100%', lg: 563 },
            minHeight: isStackedLayout && isRegisterMode ? 0 : isStackedLayout ? 0 : isSideBySide ? 0 : panelMinHeight,
            height: isSideBySide ? '100%' : isStackedLayout ? undefined : { lg: '100%' },
            maxHeight: isSideBySide
                ? '100%'
                : isStackedLayout && isRegisterMode
                    ? { xs: '38%', sm: '34%' }
                    : undefined,
            minWidth: 0,
            overflow: 'hidden',
            ...(isStackedLayout &&
                isRegisterMode && {
                flex: '0 1 42%'
            }),
            ...(isStackedLayout &&
                !isRegisterMode && {
                flex: 1,
                minHeight: 0
            })
        },
        summaryPanel: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            width: '100%',
            height: '100%',
            minHeight: isStackedLayout || isSideBySide ? 0 : panelMinHeight,
            maxHeight: '100%',
            overflow: 'hidden'
        },
        summaryImageWrap: {
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'center',
            px: isRegisterMode
                ? { xs: 1.25, sm: 1.5, md: 2.5 }
                : isPreviewStacked
                    ? contentPx
                    : { xs: 2, sm: 3 },
            pt: isRegisterMode
                ? { xs: 1.25, sm: 1.5, md: 2 }
                : isPreviewStacked
                    ? contentPt
                    : { xs: 2, sm: 3 }
        },
        summaryScroll: {
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
            px: isRegisterMode
                ? { xs: 1.25, sm: 2, md: 3, lg: 4 }
                : isPreviewStacked
                    ? contentPx
                    : { xs: 3, sm: 4, lg: 6 },
            pb: isRegisterMode
                ? { xs: 1, sm: 1.5, md: 2 }
                : isPreviewStacked
                    ? contentPb
                    : { xs: 2, sm: 3 },
            pt: isRegisterMode ? { xs: 1, sm: 1.25, md: 1.5 } : isPreviewStacked ? 1.5 : 3,
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': {
                display: 'none'
            }
        },
        stepperSection: {
            flexShrink: 0,
            px: contentPx,
            pt: contentPt,
            pb: contentPb
        },
        playIcon: {
            color: '#637381',
            width: isPreviewStacked ? 40 : 48,
            height: isPreviewStacked ? 40 : 48,
            position: 'absolute',
            top: isPreviewStacked ? 8 : 12,
            right: isPreviewStacked ? 8 : 12,
            zIndex: 2,
            background: '#FFFFFF',
            border: '1px solid #00244D33',
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        form: {
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        },
        scrollable: {
            width: '100%',
            flex: 1,
            minHeight: 0,
            px: contentPx,
            pb: isRegisterMode ? { xs: 0.75, sm: 1 } : isPreviewStacked ? 1 : 2,
            pt: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: isRegisterMode ? { xs: '8px', sm: '10px', md: '12px' } : isPreviewStacked ? '10px' : '12px',
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': {
                display: 'none'
            }
        },
        actionsWrap: {
            flexShrink: 0,
            px: contentPx,
            pb: isRegisterMode ? { xs: 1.25, sm: 1.5, md: 2.5, lg: 3 } : isPreviewStacked ? 1.5 : { xs: 3, md: 4 },
            pt: isRegisterMode ? { xs: 0.75, sm: 1, md: 1.5 } : isPreviewStacked ? 1 : 2,
            borderTop: '1px solid #00244D1A',
            backgroundColor: '#FFFFFF'
        },
        actions: {
            display: 'flex',
            flexDirection: { xs: 'column-reverse', lg: 'row' },
            gap: 1
        },
        backButton: {
            borderColor: '#00244D33',
            color: '#00244D',
            minWidth: { xs: '100%', lg: 160 },
            maxWidth: { xs: '100%', lg: 160 }
        },
        nextButton: {
            backgroundColor: '#00244D',
            textTransform: 'none',
            flex: 1,
            '&:hover': {
                backgroundColor: '#001a38'
            }
        }
    };
};
